<template>
    <v-combobox
        v-model="decision"
        :items="options"
        :label="label"
        prepend-icon="mdi-chevron-down-circle"
        clearable
        chips>
    </v-combobox>
</template>

<script>
    import { eventBus } from '../../../../../main';


    export default {
        name : 'yesnocombo',

        /* >>> *************************************************************** / /* Props */
        props : {

            value : [ Boolean, null ],
            label : String

        }, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
        created: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/YesnoCombo.vue >>> created');
            eventBus.$on('dragendproceedingslist', this.onDragend_InSelectedProceedingsList);
            eventBus.$on('dragendtrainingslist', this.onDragend_InSelectedTrainingsList);

        }, // eo function created()


        /***********************************************************************
        * Lifecyclehook::mounted
        *
        * Desc:
        * Note:
        *
        */
        mounted: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/YesnoCombo.vue >>> mounted');
            this.setTrueOrFalse();

        }, // eo function mounted()


        /***********************************************************************
        * Lifecyclehook::beforeDestroy
        *
        * Desc: Destroy Listener.
        * Note: No need to reset something here.
        *
        */
        beforeDestroy: function() {

            let me = this;


            me.$toc('>>> views/crewplanning/crewplanning/components/calendar/YesnoCombo.vue >>> beforeDestroy');
            eventBus.$off('dragendproceedingslist', this.onDragend_InSelectedProceedingsList);
            eventBus.$off('dragendtrainingslist', this.onDragend_InSelectedTrainingsList);

            this.decision = null; // reset

        }, // eo function beforeDestroy()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
        data() {

            return {
                decision: null,
                options: [
                    true,
                    false
                ],
            };

        }, // eo function data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Watch */
        watch : {

            value() {

                this.setTrueOrFalse();

            }, // eo value()

            decision(value) {

                this.$emit('input', value);

            }, // eo checkbox()

        }, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods : {

            /******************************************************************* 'Listeners - Eventbus'
            * Listeners:EventBus:
            *******************************************************************/
            /******************************************************************* 'Proceedings - Drop'
            * onDragend_InSelectedProceedingsList()
            *
            * Desc:
            * Note:
            *
            */
            onDragend_InSelectedProceedingsList: function(params) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/YesnoCombo.vue >>> onDragend_InSelectedProceedingsList');
                this.decision = params.proObject.toFlight; // set dropped

            }, // eo function onDragend_InSelectedProceedingsList()


            /******************************************************************* 'Trainings - Drop'
            * onDragend_InSelectedTrainingsList()
            *
            * Desc:
            * Note:
            *
            */
            onDragend_InSelectedTrainingsList: function(params) {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/YesnoCombo.vue >>> onDragend_InSelectedTrainingsList');
                this.decision = params.trainingObject.activated; // set dropped

            }, // eo function onDragend_InSelectedTrainingsList()




            /*******************************************************************
            * Setters:
            *******************************************************************/
            /*******************************************************************
            * setTrueOrFalse()
            *
            * Desc:
            * Note:
            *
            */
            setTrueOrFalse: function() {

                let me = this;


                me.$toc('>>> views/crewplanning/crewplanning/components/calendar/YesnoCombo.vue >>> setTrueOrFalse');
                me.decision = this.value;

            }, // eo function setTrueOrFalse()

        } // eo methods{}
        /* <<< ****************************************************************/

    };
</script>

<style>
</style>